import { List } from "immutable";
import { IDesktopInfo, INotepadInfo, IPanelInfo, ISessionInfo, ISettings } from "./Model";
import { createLocalStore } from "./utils";

const systemStorage = createLocalStore("system");

const SESSION_ITEM_KEY = "SESSION";
const SETTINGS_ITEM_KEY = "SETTINGS";
const PANELS_ITEM_KEY = "PANELS";
const NOTEPADS_ITEM_KEY = "NOTEPADS";
const DESKTOP_ITEM_KEY = "DESKTOP";

export const readSystemSession = () => systemStorage.getItem<ISessionInfo>(SESSION_ITEM_KEY);
export const writeSystemSession = (value: ISessionInfo) => systemStorage.setItem(SESSION_ITEM_KEY, value);

export const readSystemSettings = () => systemStorage.getItem<ISettings>(SETTINGS_ITEM_KEY);
export const writeSystemSettings = (value: ISettings) => systemStorage.setItem(SETTINGS_ITEM_KEY, value);

export const readSystemPanels = () => systemStorage.getItem<List<IPanelInfo>>(PANELS_ITEM_KEY);
export const writeSystemPanels = (value: List<IPanelInfo>) => systemStorage.setItem(PANELS_ITEM_KEY, value);

export const readSystemDesktop = () => systemStorage.getItem<IDesktopInfo>(DESKTOP_ITEM_KEY);
export const writeSystemDesktop = (value: IDesktopInfo) => systemStorage.setItem(DESKTOP_ITEM_KEY, value);

export const readSystemNotepadInfo = () => systemStorage.getItem<List<INotepadInfo>>(NOTEPADS_ITEM_KEY);
export const writeSystemNotepadInfo = (value: List<INotepadInfo>) => systemStorage.setItem(NOTEPADS_ITEM_KEY, value);
